<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الصورة:</label>
            <input type="file" class="form-control" @change="setImage($event.target.files)">
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <img v-if="dataRow && dataRow.image" :src="MEDIA_URL+dataRow.image" class="img-thumbnail" style="max-width: 200px;" alt="">
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">وصف مختصر - عربي:</label>
            <input type="text" v-model="title" class="form-control">
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">وصف مختصر - إنجليزي:</label>
            <input type="text" v-model="titleEn" class="form-control english-input">
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <label for="" class="form-label">الموضوع - عربي:</label>
            <textarea v-model="subject" class="form-control" rows="5"></textarea>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <label for="" class="form-label">الموضوع - إنجليزي:</label>
            <textarea v-model="subjectEn" class="form-control english-input" rows="5"></textarea>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">حالة الموضوع:</label>
            <select v-model="isActive" class="form-control">
              <option :value="true">منشور</option>
              <option :value="false">غير منشور</option>
            </select>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast } from '@/helpers/tools';

export default {
  name: 'ForumsForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      title: '',
      titleEn: '',
      subject: '',
      subjectEn: '',
      image: null,
      isActive: true,
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL'])
  },
  methods: {
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;
      
      if(!this.title || this.title.trim() == '' || !this.subject || this.subject.trim() == '' || 
        !this.titleEn || this.titleEn.trim() == '' || !this.subjectEn || this.subjectEn.trim() == ''
      ){
        this.message = 'كل الحقول مطلوبة';
        this.errorNumber = 0;
        this.hasError = true;
        this.formLoader = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return false;
      }
      const payload = new FormData();
      payload.append('title', this.title.trim());
      payload.append('titleEn', this.titleEn.trim());
      payload.append('subject', this.subject.trim());
      payload.append('subjectEn', this.subjectEn.trim());
      payload.append('isActive', this.isActive);
      if(this.image)
        payload.append('image', this.image);

      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/forums/update/${this.dataRow.id}`, payload);
      else
        api = this.$http.post('/api/admin/forums/create', payload);
      api.then(({data}) => {
        if(!this.dataRow){
          toast('تم إضافة الإعداد بنجاح', 'success');
          this.$router.replace('/forums').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
    setImage(files){
      this.image = files[0];
    },
  },
  created(){
    if(this.dataRow){
      this.title = this.dataRow.title;
      this.titleEn = this.dataRow.titleEn;
      this.subject = this.dataRow.subject;
      this.subjectEn = this.dataRow.subjectEn;
      this.isActive = this.dataRow.isActive;
    }
  }
}
</script>
